export function ItalicIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M11.7596 9H13.7596L11.5596 19H9.55957L11.7596 9ZM13.4396 5C13.2418 5 13.0484 5.05865 12.884 5.16853C12.7196 5.27841 12.5914 5.43459 12.5157 5.61732C12.44 5.80004 12.4202 6.00111 12.4588 6.19509C12.4974 6.38907 12.5926 6.56725 12.7325 6.70711C12.8723 6.84696 13.0505 6.9422 13.2445 6.98079C13.4385 7.01937 13.6395 6.99957 13.8223 6.92388C14.005 6.84819 14.1612 6.72002 14.271 6.55557C14.3809 6.39112 14.4396 6.19778 14.4396 6C14.4396 5.73478 14.3342 5.48043 14.1467 5.29289C13.9591 5.10536 13.7048 5 13.4396 5Z'
        fill='currentColor'
      />
    </svg>
  )
}
